import { render, staticRenderFns } from "./PlaceOfApprehension.vue?vue&type=template&id=5f5d3b33&scoped=true&"
import script from "./PlaceOfApprehension.vue?vue&type=script&lang=js&"
export * from "./PlaceOfApprehension.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOfApprehension.vue?vue&type=style&index=0&id=5f5d3b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d3b33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VDataTable,VPagination,VRow,VSelect})
